common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
        this.initScrollButton();
    },

    initSlider() {
        this.element.find('.slider')
            .owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                autoplay:true,
                autoplayTimeout:5000,
                autoplayHoverPause:true,
            });
    },

    initScrollButton() {
        // Get scroll button and add listener
        this.element.find('.scroll-button').click((e) => {
            // On click find next block and scroll to it
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.main').offset().top + 10
            }, 500);

            // Prevent default link behaviour
            e.preventDefault();
        });
    },

});
